var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const resolveDOIHandle = (handle) => __awaiter(void 0, void 0, void 0, function* () {
    // Use the doi.org api to resolve the handle and get a doi object, containing a link to the dataset description.
    const url = `https://doi.org/api/handles/${handle}`;
    const response = yield fetch(url, {
        method: 'GET',
        mode: 'cors',
        referrerPolicy: 'no-referrer-when-downgrade',
    }).then((res) => res.text());
    return response;
});
const retrieveDOIHandle = (citationUrls, instanceId) => __awaiter(void 0, void 0, void 0, function* () {
    // Get a DOI handle from the dataset using the DKRZ CERA service (or a link from citationsUrls as fallback)
    const cleanInstanceId = instanceId.endsWith('.json')
        ? instanceId.slice(0, -5)
        : instanceId;
    const doiURL = `https://www.wdc-climate.de/ui/cerarest/exportcmip6/?input=${cleanInstanceId}&wt=json`;
    let url;
    if (Array.isArray(citationUrls)) {
        url = citationUrls.filter((urlEl) => urlEl.includes('www.wdc-climate.de'))
            ? doiURL
            : citationUrls[0];
    }
    else {
        url = citationUrls.includes('www.wdc-climate.de') ? doiURL : citationUrls;
    }
    // eslint-disable-next-line
    const response = yield fetch(url, {
        method: 'GET',
        mode: 'cors',
        referrerPolicy: 'no-referrer-when-downgrade',
    }).then((res) => res.json());
    return response.identifier.id;
});
export const getDOILink = (citationUrls, instanceId) => __awaiter(void 0, void 0, void 0, function* () {
    const handle = yield retrieveDOIHandle(citationUrls, instanceId);
    if (handle) {
        const doiResponse = yield resolveDOIHandle(handle);
        try {
            const doiObject = JSON.parse(doiResponse);
            const res = doiObject.values[1].data.value;
            return res;
        }
        catch (error) {
            console.log(error);
        }
    }
    return '';
});
